import React, { Component } from "react";
import PropTypes from "prop-types";

import IconButton from "material-ui/IconButton";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import { DivHeaderActions, DivTitle } from "./styled";
import { BlockCounter, TextInput } from "./components";

class YoutubeView extends Component {
  constructor(props) {
    super(props);
    const {
      containerPadding,
      alignValue,
      fullwidth,
      videoId
    } = props.data.values;

    this.state = {
      isEditMode: false,
      expanded: true,
      fullwidth: fullwidth,
      alignValue: alignValue,
      containerPadding: containerPadding,
      videoId
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.videoId = this.state.videoId;
    newData.values.alignValue = this.state.alignValue;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.fullwidth = this.state.fullwidth;
    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };

  onChangeAlign = (event, value) => {
    this.setState({ alignValue: value });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.videoId = this.state.videoId;
    newData.values.alignValue = this.state.alignValue;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.fullwidth = this.state.fullwidth;
    localStorage.setItem("YoutubeView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const dividerContent = JSON.parse(localStorage.getItem("YoutubeView"));
    if (dividerContent) {
      const {
        containerPadding,
        fullwidth,
        alignValue,
        videoId
      } = dividerContent;
      this.setState({
        videoId,
        fullwidth,
        alignValue,
        containerPadding
      });
    }
  };
  onToggle = (e, v) => {
    this.setState({ fullwidth: v });
  };
  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Youtube"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              expandable={true}
              style={{ overflowY: "scroll", height: 500 }}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Video Id</DivTitle>
                <TextInput
                  value={this.state.videoId}
                  onChange={value => this.setState({ videoId: value })}
                  name="videoId"
                  title="Video Id"
                  fullWidth={true}
                />
              </Paper>

              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

YoutubeView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

YoutubeView.defaultProps = {
  data: {}
};
export default YoutubeView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/YoutubeView.js